import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';

@Injectable()
export class DecreeActionTypeService {
  public constructor(private http: HttpClient) {}

  toggleDetailAction(toggledIds: string[], url: string, comment: string = '') {
    return this.http.post<void>(`${environment.BACKEND_URL + url}`, { toggledIds, comment });
  }
}
